import EditSearchResultsForm from './EditSearchResultsForm'

export default EditSearchResultsForm
